<template>
  <div id="main-content" :style="`max-height:${maxHeight}; min-height: 300px;`">
    <div class="item" v-for="(item, idx) in items" :key="item[`${itemKey}]`]">
      <slot name="body" :item="item" :idx="idx">{{ item }}</slot>
    </div>
    <div id="loader" v-show="loading">
      <!-- <div class="skeleton-card"></div> -->
      <v-progress-linear
        color="primary"
        buffer-value="0"
        stream
      ></v-progress-linear>
    </div>
  </div>
</template>

<script>
// REF https://stackoverflow.com/questions/3962558/javascript-detect-scroll-end
// REF https://webdesign.tutsplus.com/tutorials/how-to-implement-infinite-scrolling-with-javascript--cms-37055
export default {
  mounted () {
    this.mainContent = document.getElementById('main-content')
    this.loader = document.getElementById('loader')
    this.mainContent.addEventListener('scroll', this.handleInfiniteScroll)
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      // TODO จำนวนทั้งหมด
      type: Number,
      default: 0
    },
    increase: {
      // // TODO จำนวนต่อหน้า
      type: Number,
      default: 0
    },
    current: {
      // // TODO จำนวนต่อหน้า
      type: Number,
      default: 0
    },
    itemKey: {
      type: String,
      default: 'index'
    },
    loading: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    pageCount () {
      return Math.ceil(this.cardLimit / this.cardIncrease) // TODO จำนวนหน้าทั้งหมดจากข้อมูลทั้งหมด
    },
    items: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        return val
      }
    },
    cardLimit: {
      get () {
        return this.limit
      },
      set (val) {
        this.$emit('update:limit', val)
        return val
      }
    },
    cardIncrease: {
      get () {
        return this.increase
      },
      set (val) {
        this.$emit('update:increase', val)
        return val
      }
    },
    currentPage: {
      get () {
        return this.current
      },
      set (val) {
        this.$emit('update:current', val)
        return val
      }
    }
  },
  data () {
    return {
      xx: { item: 'hello world' },
      mainContent: null,
      cardContainer: null,
      loader: null,
      throttleTimer: false // TODO หน่วงเวลา
    }
  },
  methods: {
    throttle (callback, time) {
      if (this.throttleTimer) return
      this.throttleTimer = true
      setTimeout(() => {
        callback()
        this.throttleTimer = false
      }, time)
    },

    addCards (pageIndex) {
      // TODO เป็น Function ในการ Add Card จาก Page ที่ต้องการ
      this.currentPage = pageIndex
      const startRange = (pageIndex - 1) * this.cardIncrease
      const endRange =
        this.currentPage === this.pageCount
          ? this.cardLimit
          : pageIndex * this.cardIncrease
      this.$emit('endPage', { start: startRange, end: endRange })
    },

    handleInfiniteScroll () {
      // TODO เป็น Function ในการตรวจจับ Ending Page
      this.throttle(() => {
        // TODO offsetHeight คือ ความสูงของ parent element
        // TODO scrollTop คือ current scroll
        // TODO scrollHeight คือ ความสูงที่สุดของ Scroll

        const endOfPage =
          this.mainContent.offsetHeight + this.mainContent.scrollTop >=
          this.mainContent.scrollHeight
        if (endOfPage) {
          this.addCards(this.currentPage + 1)
        }
        if (this.currentPage === this.pageCount) {
          // TODO เมื่อเป็นหน้าสุดท้าย
          this.removeInfiniteScroll()
        }
      }, 1000)
    },

    removeInfiniteScroll () {
      this.loader.remove()
      this.mainContent.removeEventListener('scroll', this.handleInfiniteScroll)
    },

    onload () {
      // TODO เป็น function ในการ init ค่าเริ่มต้น
      this.addCards(this.currentPage)
    }
  }
}
</script>

<style lang="scss" scoped>
#main-content {
  // background: green !important;
  // background: inherit !important;
  height: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden;
  width: 100% !important;
  position: relative;
  // max-height: 50vh;
}

// #card-container {
//   width: 100%;
//   height: 100%;
//   background: gray;
//   display: flex;
//   flex-wrap: wrap;
//   /* overflow: hidden; */
// }

// ::v-deep .card {
//   height: 100px;
//   /* width: calc((100% / 3) - 16px); */
//   width: calc(100% - 16px);
//   margin: 8px;
//   border-radius: 3px;
//   transition: all 200ms ease-in-out;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .card:hover {
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
// }

// .card-actions {
//   margin: 8px;
//   padding: 16px 0;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }

#loader {
  // display: flex;
  padding: 8px;
}

.skeleton-card {
  height: 50px;
  /* height: 55vh; */
  width: calc(100%);
  /* width: calc((100% / 3) - 16px); */
  // margin: 8px;
  border-radius: 3px;
  transition: all 100ms ease-in-out;
  position: relative;
  overflow: hidden;
  background-color: var(--v-primary-base);
}

.skeleton-card::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(#fff, 0) 0,
    rgba(#fff, 0.2) 20%,
    rgba(#fff, 0.5) 60%,
    rgba(#fff, 0)
  );
  animation: load 2s infinite;
}

@keyframes load {
  100% {
    transform: translateX(100%);
  }
}

@media screen and (prefers-reduced-motion: reduce) {
  .skeleton-card::after {
    animation: none;
  }
}
</style>
